import {makeStyles} from "@material-ui/core/styles";
import {MaterialUiPickersDate} from "@material-ui/pickers/typings/date";
import {WorkerDay} from "../../../orders/redux/types";
import React, {FC} from "react";
import clsx from "clsx";
import {IconButton} from "@material-ui/core";
import {formatDate} from "../../../../date.utils";
import {useHistory} from "react-router-dom";
import {CalendarDayDialog} from "./CalendarDayDialog";

const useDayStyles = makeStyles((theme) => ({
    day: {
        width: "36px",
        height: "36px",
        fontSize: "0.95rem",
        margin: "0 2px",
        padding: 0,
        color: "inherit",
        fontWeight: 500,
        flex: "auto",
        overflow: "visible",
        textAlign: "center"
    },
    today: {
        color: theme.palette.error.main
    },
    hasOrder: {
        backgroundColor: theme.palette.warning.light
    },
    hasAvailability: {
        backgroundColor: theme.palette.primary.main
    }
}));

interface CustomCalendarDayProps {
    date: MaterialUiPickersDate;
    disabled?: boolean;
    today?: boolean;
    workerDay?: WorkerDay;
    workerId: string;
}

export const CalendarDay: FC<CustomCalendarDayProps> = ({date, disabled, today, workerDay, workerId}) => {
    const classes = useDayStyles();
    const history = useHistory();
    const navigateToCreateAvailability = () => {
        const newSearchParams = new URLSearchParams(history.location.search);
        newSearchParams.set('mode', 'create');
        newSearchParams.set('workerId', workerId);
        newSearchParams.set('initialDate', String((date ?? new Date()).getTime()));
        history.replace({
            pathname: history.location.pathname,
            search: `${newSearchParams.toString()}`,
            hash: 'availability'
        })
    };
    const filteredOrders = workerDay?.orders.filter(o => o.confirmed && !o.cancellation);
    const buttonClasses = clsx(
        classes.day,
        today && classes.today,
        filteredOrders && filteredOrders.length > 0 ? classes.hasOrder : workerDay?.availability && classes.hasAvailability
    );

    const [dialogOpen, setDialogOpen] = React.useState(false);

    return (
        <div>
            {workerDay && date &&
            <CalendarDayDialog
                dayDate={date}
                toggleDialog={() => setDialogOpen(p => !p)}
                open={dialogOpen}
                workerDay={workerDay}
            />}
            <div role="presentation">
                <IconButton
                    disabled={disabled}
                    className={buttonClasses}
                    onClick={() => {
                        if (!disabled && !workerDay?.availability && workerDay?.orders.length === 0) {
                            navigateToCreateAvailability();
                        } else {
                            setDialogOpen(true);
                        }
                    }}
                >
                    <span>{formatDate(date, "d")}</span>
                </IconButton>
            </div>
        </div>
    )
}
